/**
 * Normalisiert E-Mail-Adressen für Auth-Abgleich (Spiegel der Postgres-Funktion).
 * @param {string} email
 * @returns {string}
 */
export function normalizeEmailForAuthMatch(email) {
  const raw = String(email ?? "").trim().toLowerCase();
  if (!raw || !raw.includes("@")) return raw;

  const at = raw.lastIndexOf("@");
  let local = raw.slice(0, at);
  let domain = raw.slice(at + 1);

  if (domain === "googlemail.com") domain = "gmail.com";
  if (domain === "gmail.com") local = local.replace(/\./g, "");

  return `${local}@${domain}`;
}

/**
 * @param {string} a
 * @param {string} b
 * @returns {boolean}
 */
export function authEmailsEquivalent(a, b) {
  const left = normalizeEmailForAuthMatch(a);
  const right = normalizeEmailForAuthMatch(b);
  return !!left && left === right;
}
